import { render, staticRenderFns } from "./CardPriceTypeOffering.vue?vue&type=template&id=58970811&scoped=true"
import script from "./CardPriceTypeOffering.vue?vue&type=script&lang=js"
export * from "./CardPriceTypeOffering.vue?vue&type=script&lang=js"
import style0 from "./CardPriceTypeOffering.vue?vue&type=style&index=0&id=58970811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58970811",
  null
  
)

export default component.exports